module.exports = __webpack_public_path__ + "img/ics.6a3595e6.svg";